import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import DefaultModal from 'components/Utils/DefaultModal';
import FaxDetails from 'components/HealthRecords/Faxes/FaxDetails';

const CPPTimelineFax = ({ fax }) => {
  let [openPreview, setOpenPreview] = useState(false);

  async function getFaxPDF() {
    setOpenPreview(true);
  }

  function closePreview() {
    setOpenPreview(false);
  }

  return (
    <>
      <FaxPreview openPreview={openPreview} closePreview={closePreview} fax={fax} />
      <div className="item-wrapper clickable timeline-fax" onClick={getFaxPDF}>
        <div className="top-bar">
          <Icon src="fax" />
          <span className="small-title">Fax</span>
        </div>
        <div className="item-content">
          <span className="inline-block">{fax.title}</span>
          <span className="inline-block">To: {fax.to}</span>
          <span className="inline-block">Status: {fax.status}</span>
        </div>
      </div>
    </>
  );
};

export const FaxPreview = React.memo(({ closePreview, openPreview, fax, onChanged }) =>
  openPreview ? (
    <DefaultModal
      className="large-modal"
      key="fax-details-modal"
      wrap={true}
      padding={false}
      title="Fax"
      content={<FaxDetails fax={fax} allowExpand={true} onChanged={onChanged} />}
      isOpen={openPreview}
      onRequestClose={closePreview}
    />
  ) : null,
);

CPPTimelineFax.propTypes = {
  fax: PropTypes.object.isRequired,
};

export default CPPTimelineFax;
